import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import MDBadge from "components/MDBadge";
import Divider from "@mui/material/Divider";
import MDTypography from "components/MDTypography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css";
import Select from "react-select";
import InputMask from "react-input-mask";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import step from "assets/theme/components/stepper/step";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
const ProgramCorrection = () => {
  const [campaignId, setCampaignId] = useState(null);
  const [form_no, setFormNo] = useState("");
  const [applicant_cnic, setApplicantCnic] = useState("");
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [application_type, setApplicationType] = useState("");
  const [applicationId, setApplicationId] = useState(null);
  const [programLoading, setProgramLoading] = useState(false);
  const [tests, setTests] = useState([]);
  const [selectedDegrees, setSelectedDegrees] = useState([]);
  const [selectedCampus, setSelectedCampus] = useState(null);
  const [tempSelectedQuotas, setTempSelectedQuotas] = useState({});
  const [degrees, setDegrees] = useState([]);
  const [originalDegrees, setOriginalDegrees] = useState([]);
  const [selectedFaculty, setSelectedFaculty] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedProgramLevel, setSelectedProgramLevel] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [campuses, setCampuses] = useState([]);
  const [faculties, setFaculties] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [touchStartY, setTouchStartY] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [showAllQuotas, setShowAllQuotas] = useState({});
  const [maxPreferences, setMaxPreferences] = useState("");
  const [allTests, setAllTests] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const [selectedProgramTypes, setSelectedProgramTypes] = useState({});
  const [cachedDegree, setCachedDegrees] = useState([]);
  const fetchApplication = async () => {
    if (!campaignId) {
      toast.error("Please select a campaign.");
      return;
    }

    try {
      const payload = {
        campaign_id: campaignId,
        applicant_cnic: applicant_cnic,
        application_id: form_no,
      };

      const response = await fetch(
        BASE_URL + `/submit_application/get_application_by_cnic_or_id`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      const application = data.application;

      setApplicationId(application.id);
      setApplicationType(application.application_type);
      setMaxPreferences(application.max_preferences);
      if (data.programs.length > 0) {
        getDegreesInCampaign(application.id);
        setSelectedDegrees(data.programs);
      }
    } catch (error) {
      console.log("Error fetching application:", error);
    }
  };
 const getDegreesInCampaign = async (application_id) => {
    setProgramLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/submit_application/get_degrees_in_campaign/${application_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const jsonData = await response.json();
      const degrees = jsonData.degrees;
      // Custom sort: prioritize 'Morning' before 'Evening'
      degrees.sort((a, b) => {
        // Compare base names (ignoring "Morning"/"Evening")
        const baseA = a.program_name
          .replace(/\s*\((Morning|Evening)\)/i, "")
          .trim();
        const baseB = b.program_name
          .replace(/\s*\((Morning|Evening)\)/i, "")
          .trim();

        if (baseA !== baseB) {
          return baseA.localeCompare(baseB, undefined, { sensitivity: "base" });
        }

        // Now compare Morning/Evening
        const isMorningA = /morning/i.test(a.program_name);
        const isMorningB = /morning/i.test(b.program_name);

        if (isMorningA && !isMorningB) return -1;
        if (!isMorningA && isMorningB) return 1;
        return 0;
      });
      setCachedDegrees(degrees);
      setDegrees(degrees);
      const initialTempQuotas = {};
      degrees.forEach((degree) => {
        const openMeritQuota = degree.criterias.find(
          (quota) => quota.quota_name === "Open Merit" && quota.eligible
        );

        if (openMeritQuota) {
          initialTempQuotas[degree.program_id] = [
            {
              program_id: degree.program_id,
              program_name: degree.program_name,
              program_group: degree.program_group,
              quota_name: "Open Merit",
              quota_id: openMeritQuota.quota_id,
              test_required: openMeritQuota.test_required || "no",
              test_name: openMeritQuota.test_name || "",
            },
          ];
        }
      });

      setTempSelectedQuotas(initialTempQuotas);
      setProgramLoading(false);
    } catch (error) {
      console.error(error);
    }
  };
  const parseTestNames = (testNameStr) => {
    // if (!testNameStr) return ["University Test"];
    try {
      // Parse the string representation of array
      const testArray = JSON.parse(testNameStr.replace(/'/g, '"'));
      // Include University Test if not present
      // if (!testArray.includes("University Test")) {
      //   testArray.push("University Test");
      // }
      return testArray;
    } catch (e) {
      console.error("Error parsing test names:", e);
    }
  };

  const applyProgram = (
    programId,
    programName,
    programGroup,
    enableCourseWorkOption = 0
  ) => {
    const programQuotas = tempSelectedQuotas[programId] || [];

    if (programQuotas.length === 0) {
      toast.error("Please select at least one quota for this program");
      return;
    }

    // Get the selected program type for this program (default to 'research' if not selected)
    const selectedProgramType = selectedProgramTypes[programId] || "research";

    // Extract base program name
    const { baseName } = extractProgramDetails(programName, programGroup);

    // Check if we already have this base program in our preferences
    const programBaseNameExists = Object.keys(groupedSelectedDegrees).includes(
      baseName
    );

    // If this exact program exists, remove it first (to update its quotas)
    setSelectedDegrees((prev) =>
      prev.filter((degree) => degree.program_name !== programName)
    );

    // Check if we've reached the maximum number of different base programs
    if (!programBaseNameExists) {
      const currentUniqueBasePrograms = Object.keys(
        groupedSelectedDegrees
      ).length;
      if (currentUniqueBasePrograms >= maxPreferences) {
        toast.error(`You can only select ${maxPreferences} program groups`);
        return;
      }
    }

    // Add the program with selected quotas, program type, and enable_course_work_option
    const programQuotasWithType = programQuotas.map((quota) => ({
      ...quota,
      program_type: selectedProgramType, // Add program type to each quota
      enable_course_work_option: enableCourseWorkOption, // Add enable_course_work_option
    }));

    setSelectedDegrees((prev) => [
      ...prev.filter((d) => d.program_name !== programName),
      ...programQuotasWithType,
    ]);

    // Rest of the function remains the same...
    const newTests = new Set();
    programQuotas.forEach((quota) => {
      if (quota.test_required === "yes" && quota.test_name) {
        const testNames = parseTestNames(quota.test_name);
        testNames.forEach((testName) => newTests.add(testName));
      }
    });

    setTests((prevTests) => {
      const existingTestTypes = new Set(prevTests.map((test) => test.type));
      const testsToAdd = Array.from(newTests)
        .filter((testName) => !existingTestTypes.has(testName))
        .map((testName) => ({
          type: testName,
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          test_date: "",
          isRequired: true,
        }));
      return [...prevTests, ...testsToAdd];
    });

    setAllTests((prev) => {
      const existingTestTypes = new Set(prev.map((test) => test.type));
      const testsToAdd = Array.from(newTests)
        .filter((testName) => !existingTestTypes.has(testName))
        .map((testName) => ({
          type: testName,
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          test_date: "",
          isRequired: true,
        }));
      return [...prev, ...testsToAdd];
    });

    const successMessage = programBaseNameExists
      ? `Updated quotas for ${programName}`
      : `${programName} has been added to your preferences`;

    toast.success(successMessage);
  };
  const handleProgramTypeChange = (programId, programType) => {
    setSelectedProgramTypes((prev) => ({
      ...prev,
      [programId]: programType,
    }));
  };

  // Helper function to extract base program name and session

  // Helper function to extract base program name and session
  const extractProgramDetails = (programName, group, department) => {
    const sessionPatterns = [
      "Morning",
      "Evening",
      "Weekend",
      "Afternoon",
      "Day",
      "Weekend",
    ];
    let session = group;
    let baseName = programName;

    // Match the last parentheses at the end and check if it contains a known session
    const match = programName.match(/\(([^)]+)\)\s*$/);

    if (match && sessionPatterns.includes(match[1])) {
      session = match[1];
      // Remove the session part from the end to get the base name
      baseName = programName.slice(0, match.index).trim();
    }

    return { baseName, session, department };
  };

  // Modified groupedSelectedDegrees to group by base program name
const groupedSelectedDegrees = selectedDegrees.reduce((acc, degree) => {
    // console.log(degree);
    const { baseName, session } = extractProgramDetails(
      degree.program_name,
      degree.program_group
    );

    if (!acc[baseName]) {
      acc[baseName] = {
        sessions: new Set(),
        quotas: new Set(),
        programIds: new Set(),
        originalProgramNames: new Set(),
        degrees: [], // Store all degree objects
        program_type: null, // Store program type
        enable_course_work_option: 0, // Store enable_course_work_option
      };
    }

    // Add session
    acc[baseName].sessions.add(session);

    // Add quota
    acc[baseName].quotas.add(degree.quota_name);

    // Store program ID for future reference
    acc[baseName].programIds.add(degree.program_id);

    // Store original program name for reference
    acc[baseName].originalProgramNames.add(degree.program_name);

    // Store the complete degree object
    acc[baseName].degrees.push(degree);

    // Store program_type (all degrees in same group should have same type)
    if (degree.program_type) {
      acc[baseName].program_type = degree.program_type;
    }

    // Store enable_course_work_option (all degrees in same group should have same value)
    if (degree.enable_course_work_option !== undefined) {
      acc[baseName].enable_course_work_option =
        degree.enable_course_work_option;
    }

    return acc;
  }, {});


  // Drag and drop handlers
  // Drag and drop handlers
  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", e.target.outerHTML);
    e.dataTransfer.setDragImage(e.target, 0, 0);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";

    // Find the closest draggable element
    const target = e.currentTarget;
    const rect = target.getBoundingClientRect();
    const index = parseInt(
      target.getAttribute("data-index") ||
        target.parentElement.getAttribute("data-index")
    );

    if (!isNaN(index)) {
      setDragOverIndex(index);
    }
  };

  // Touch handlers for mobile
  const handleTouchStart = (e, index) => {
    setTouchStartY(e.touches[0].clientY);
    setDraggedIndex(index);
    setIsDragging(false);

    // Prevent scrolling while dragging
    e.preventDefault();
  };

  const handleTouchMove = (e) => {
    if (draggedIndex === null || touchStartY === null) return;

    e.preventDefault();
    const currentY = e.touches[0].clientY;
    const deltaY = currentY - touchStartY;

    // Start dragging if moved more than 10px
    if (Math.abs(deltaY) > 10) {
      setIsDragging(true);
    }

    if (!isDragging) return;

    // Find which item we're hovering over
    const elements = document.querySelectorAll("[data-drag-item]");
    let targetIndex = draggedIndex;

    elements.forEach((el, idx) => {
      const rect = el.getBoundingClientRect();
      if (currentY >= rect.top && currentY <= rect.bottom) {
        targetIndex = idx;
      }
    });

    setDragOverIndex(targetIndex);
  };

  const handleTouchEnd = (e) => {
    if (!isDragging) {
      // If not dragging, reset everything
      setDraggedIndex(null);
      setDragOverIndex(null);
      setTouchStartY(null);
      setIsDragging(false);
      return;
    }

    // Perform the drop
    if (
      draggedIndex !== null &&
      dragOverIndex !== null &&
      draggedIndex !== dragOverIndex
    ) {
      moveItemToPosition(draggedIndex, dragOverIndex);
    }

    // Reset all drag states
    setDraggedIndex(null);
    setDragOverIndex(null);
    setTouchStartY(null);
    setIsDragging(false);
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();

    if (draggedIndex === null || draggedIndex === dropIndex) {
      return;
    }

    moveItemToPosition(draggedIndex, dropIndex);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
    setDragOverIndex(null);
  };


  // Modified handleDeleteProgram to delete all programs with the same base name
// Helper function to move items
  const moveItemToPosition = (fromIndex, toIndex) => {
    // Get array of base program names in order
    const groupedPrograms = Object.keys(groupedSelectedDegrees);

    // Create a new array with the item moved
    const newOrder = [...groupedPrograms];
    const draggedItem = newOrder[fromIndex];

    // Remove the dragged item and insert it at the new position
    newOrder.splice(fromIndex, 1);
    newOrder.splice(toIndex, 0, draggedItem);

    // Create a new order mapping for all programs
    const orderMapping = {};
    newOrder.forEach((baseName, idx) => {
      // Get all original program names that belong to this base name
      groupedSelectedDegrees[baseName].originalProgramNames.forEach(
        (originalName) => {
          orderMapping[originalName] = idx;
        }
      );
    });

    // Sort selectedDegrees based on the new order
    const sortedDegrees = [...selectedDegrees].sort((a, b) => {
      return orderMapping[a.program_name] - orderMapping[b.program_name];
    });

    // Update state
    setSelectedDegrees(sortedDegrees);
  };

  // Modified handleDeleteProgram to delete all programs with the same base name
  const handleDeleteProgram = (baseProgramName) => {
    // Get all original program names that belong to this base program
    const originalProgramNames =
      groupedSelectedDegrees[baseProgramName].originalProgramNames;

    // Get all programs that are being deleted
    const programsToDelete = selectedDegrees.filter((degree) =>
      originalProgramNames.has(degree.program_name)
    );

    // Get the remaining programs after deletion
    const remainingPrograms = selectedDegrees.filter(
      (degree) => !originalProgramNames.has(degree.program_name)
    );

    // Keep track of all test names required by deleted programs
    const deletedProgramTests = programsToDelete
      .filter((degree) => degree.test_required === "yes" && degree.test_name)
      .flatMap((degree) => parseTestNames(degree.test_name));

    // Remove duplicates from test names
    const uniqueDeletedTests = [...new Set(deletedProgramTests)];

    // Check each test if it's still needed by any remaining program
    uniqueDeletedTests.forEach((testName) => {
      const testStillNeeded = remainingPrograms.some(
        (degree) =>
          degree.test_required === "yes" &&
          degree.test_name &&
          parseTestNames(degree.test_name).includes(testName)
      );

      if (!testStillNeeded) {
        // Remove the test since no remaining program requires it
        setTests((prevTests) =>
          prevTests.filter((test) => test.type !== testName)
        );
        setSelectedTests((prevSelected) =>
          prevSelected.filter((name) => name !== testName)
        );
        setAllTests((prevAll) =>
          prevAll.filter((test) => test.type !== testName)
        );
      }
    });

    // Remove the programs
    setSelectedDegrees(remainingPrograms);

    toast.info(`${baseProgramName} removed from preferences`);
  };
  const submitStep3 = async () => {
    let data = {
      step: 3,
      application_id: applicationId,
      programs: selectedDegrees,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(
      `${BASE_URL}/submit_application/submit_program_correction`,
      requestOptions
    );

    const result = await response.json();
    toast.success(result.error);
    if (result.success) {
      toast.success("Application Programs Submited Successfully");
    } else {
      toast.error("Some thing went wrong");
    }
  };
  const handleQuotaSelection = (
    programId,
    programName,
    quotaName,
    quotaId,
    test_required,
    test_name
  ) => {
    // Skip toggle selection if it's Open Merit (always pre-selected)
    if (quotaName === "Open Merit") {
      return;
    }

    // Check if the quota is already temporarily selected
    const programQuotas = tempSelectedQuotas[programId] || [];
    const isSelected = programQuotas.some(
      (quota) => quota.quota_id === quotaId
    );

    if (isSelected) {
      // Remove the quota from temporary selection
      const updatedProgramQuotas = programQuotas.filter(
        (quota) => quota.quota_id !== quotaId
      );

      setTempSelectedQuotas({
        ...tempSelectedQuotas,
        [programId]: updatedProgramQuotas,
      });
    } else {
      // Add the quota to temporary selection
      const updatedProgramQuotas = [
        ...programQuotas,
        {
          program_id: programId,
          program_name: programName,
          quota_name: quotaName,
          quota_id: quotaId,
          test_required: test_required || "no",
          test_name: test_name || "",
        },
      ];

      setTempSelectedQuotas({
        ...tempSelectedQuotas,
        [programId]: updatedProgramQuotas,
      });
    }
  };

  const fetchAllCampaigns = async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await fetch(
        BASE_URL + `/campaign/get_campaigns`,
        requestOptions
      );
      const data = await response.json();
      setAllCampaigns(data.campaigns);
    } catch (error) {
      console.log("Error fetching campaigns:", error);
    }
  };
  const handleCampaignChange = (selectedOption) => {
    setCampaignId(selectedOption.value);
  };
  // Fetch campuses on component mount
  useEffect(() => {
    fetchCampuses();
  }, []);

  // Fetch campuses on component mount
  const fetchCampuses = async () => {
    try {
      const response = await fetch(`${BASE_URL}/campus/get_campuses`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch campuses");
      }

      const data = await response.json();

      // Transform data for react-select
      const formattedCampuses = [
        { value: "All", label: "All" },
        ...data.campuses.map((campus) => ({
          value: campus.id,
          label: campus.name,
        })),
      ];

      setCampuses(formattedCampuses);
    } catch (error) {
      console.error("Error fetching campuses:", error);
    }
  };

  // Fetch faculties based on selected campus
  const fetchFaculties = async (campusId) => {
    if (campusId === "All") {
      setFaculties([{ value: "All", label: "All" }]);
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL}/faculty/get_faculties_by_campus/${campusId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch faculties");
      }

      const data = await response.json();

      // Transform data for react-select
      const formattedFaculties = [
        { value: "All", label: "All" },
        ...data.faculties.map((faculty) => ({
          value: faculty.id,
          label: faculty.name,
        })),
      ];

      setFaculties(formattedFaculties);
      setSelectedFaculty(null);
      setDepartments([{ value: "All", label: "All" }]);
      setSelectedDepartment(null);
    } catch (error) {
      console.error("Error fetching faculties:", error);
    }
  };

  // Fetch departments based on selected faculty
  const fetchDepartments = async (facultyId) => {
    if (facultyId === "All") {
      setDepartments([{ value: "All", label: "All" }]);
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL}/department/get_departments_by_faculty/${facultyId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch departments");
      }

      const data = await response.json();

      // Transform data for react-select
      const formattedDepartments = [
        { value: "All", label: "All" },
        ...data.departments.map((department) => ({
          value: department.id,
          label: department.name,
        })),
      ];

      setDepartments(formattedDepartments);
      setSelectedDepartment(null);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };
  // Handle campus change
  const handleCampusChange = (selectedOption) => {
    setSelectedCampus(selectedOption);
    if (selectedOption) {
      fetchFaculties(selectedOption.value);
    } else {
      setFaculties([]);
      setDepartments([]);
    }
  };
  // Handle faculty change
  const handleFacultyChange = (selectedOption) => {
    setSelectedFaculty(selectedOption);
    if (selectedOption) {
      fetchDepartments(selectedOption.value);
    } else {
      setDepartments([]);
    }
  };

  // Handle department change
  const handleDepartmentChange = (selectedOption) => {
    setSelectedDepartment(selectedOption);
  };

  // Handle program level change
  const handleProgramLevelChange = (selectedOption) => {
    setSelectedProgramLevel(selectedOption);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  // Function to filter degrees based on selected filters
  const filterDegrees = () => {
    // Start with the original degrees list
    let filteredDegrees = [...degrees];

    // Apply campus filter
    if (selectedCampus && selectedCampus.value !== "All") {
      filteredDegrees = filteredDegrees.filter(
        (degree) => degree.campus_id === selectedCampus.value
      );
    }

    // Apply faculty filter
    if (selectedFaculty && selectedFaculty.value !== "All") {
      filteredDegrees = filteredDegrees.filter(
        (degree) => degree.faculty_id === selectedFaculty.value
      );
    }

    // Apply department filter
    if (selectedDepartment && selectedDepartment.value !== "All") {
      filteredDegrees = filteredDegrees.filter(
        (degree) => degree.department_id === selectedDepartment.value
      );
    }

    // Apply program level filter
    if (selectedProgramLevel && selectedProgramLevel.value !== "All") {
      filteredDegrees = filteredDegrees.filter(
        (degree) => degree.program_level === selectedProgramLevel.value
      );
    }

    // Apply search query
    if (searchQuery) {
      filteredDegrees = filteredDegrees.filter((degree) =>
        degree.program_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setDegrees(filteredDegrees);
  };

  // Function to reset filters
  const resetFilters = async () => {
    setSelectedCampus(null);
    setSelectedFaculty(null);
    setSelectedDepartment(null);
    setSelectedProgramLevel(null);
    setSearchQuery("");
    setDegrees(originalDegrees);
  };

  // Apply filters when any filter changes
  useEffect(() => {
    // Only apply filters if we already have degrees loaded
    if (degrees.length > 0 && !programLoading) {
      filterDegrees();
    }
  }, [
    selectedCampus,
    selectedFaculty,
    selectedDepartment,
    selectedProgramLevel,
    searchQuery,
  ]);

  useEffect(() => {
    fetchAllCampaigns();
  }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  Campaigns
                </MDTypography>
                <Select
                  name="campaign_id"
                  options={all_campaigns.map((camp) => ({
                    value: camp.id,
                    label: camp.name,
                  }))}
                  className="basic-single-select"
                  classNamePrefix="select"
                  placeholder="Select Campaign"
                  onChange={handleCampaignChange}
                  value={
                    all_campaigns
                      .map((camp) => ({
                        value: camp.id,
                        label: camp.name,
                      }))
                      .find((option) => option.value === campaignId) || null
                  }
                />
              </div>
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  Form No
                </MDTypography>
                <MDInput
                  type="text"
                  label="Form No"
                  fullWidth
                  value={form_no}
                  onChange={(e) => setFormNo(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  CNIC
                </MDTypography>
                <MDInput
                  type="text"
                  label="CNIC"
                  fullWidth
                  value={applicant_cnic}
                  onChange={(e) => setApplicantCnic(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <MDBox mt={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ width: "100%", color: "white" }}
                    onClick={fetchApplication}
                  >
                    Fetch Application
                  </Button>
                </MDBox>
              </div>
            </Stack>
          </Grid>
        </Grid>
        {programLoading ? (
          <div className="text-center">
            <CircularProgress />
            <Typography variant="h6" className="mt-3">
              Please Wait Eligibility Criteria Checking ...
            </Typography>
          </div>
        ) : (
          <div className="mt-3">
            {/* Preferences Section */}
            <div className="row mb-5">
              <div className="col-md-12">
                <Typography variant="h5" className="text-danger mb-3">
                  Eligibility: You can apply to any program (Faculty of Arts &
                  Social Sciences / Science / Engineering / Agriculture) if you
                  have completed F.Sc (Pre-Medical / Pre-Engineering), A-Level
                  (Pre-Medical / Pre-Engineering), or ICS.
                </Typography>
              </div>
              <div className="col-md-12 mb-2 box p-3 bg-light">
                <Typography variant="h5" className="mb-3">
                  Program Preferences
                </Typography>

                {Object.entries(groupedSelectedDegrees).length > 0 ? (
                  Object.entries(groupedSelectedDegrees).map(
                    ([baseProgramName, details], index) => {
                      // Get program type and enable_course_work_option from the first degree in this group
                      const programType =
                        details.degrees && details.degrees.length > 0
                          ? details.degrees[0].program_type
                          : null;

                      const enableCourseWorkOption =
                        details.degrees && details.degrees.length > 0
                          ? details.degrees[0].enable_course_work_option
                          : 0;

                      const getProgramTypeDisplay = (type) => {
                        if (!type) return "";
                        switch (type) {
                          case "research":
                            return "Research Work";
                          case "course":
                            return "Course Work";
                          default:
                            return type;
                        }
                      };

                      return (
                        <div key={index}>
                          <div>
                            <div className="row mb-3 align-items-center bg-white p-2 rounded shadow-sm">
                              {/* ... drag and drop handlers ... */}
                              <div className="col-md-1 d-flex align-items-center justify-content-center">
                                <div
                                  style={{
                                    cursor: "grab",
                                    padding: "5px",
                                    color: "#666",
                                    fontSize: "18px",
                                  }}
                                  title="Drag to reorder"
                                >
                                  ⋮⋮
                                </div>
                              </div>
                              <div className="col-md-8">
                                <li>
                                  {index + 1}. {baseProgramName}{" "}
                                  {/* Display program type only if enable_course_work_option is 1 */}
                                  {programType &&
                                    enableCourseWorkOption === 1 && (
                                      <span
                                        className="badge bg-info text-white me-2"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {getProgramTypeDisplay(programType)}
                                      </span>
                                    )}
                                  {/* Display sessions if there are multiple */}
                                  {details.sessions.size > 1 ? (
                                    <span className="text-secondary">
                                      ({Array.from(details.sessions).join(", ")}
                                      )
                                    </span>
                                  ) : details.sessions.size === 1 &&
                                    Array.from(details.sessions)[0] !==
                                      "Default" ? (
                                    <span className="text-secondary">
                                      ({Array.from(details.sessions)[0]})
                                    </span>
                                  ) : null}
                                  {" - "}
                                  {Array.from(details.quotas).join(", ")}
                                </li>
                              </div>
                              <div className="col-md-3 d-flex justify-content-end">
                                <IconButton
                                  onClick={() =>
                                    handleDeleteProgram(baseProgramName)
                                  }
                                  color="error"
                                  size="small"
                                  title="Delete"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )
                ) : (
                  <div className="alert alert-info">
                    Please Scroll Down to select your program. and then click on
                    Apply Program. After that, you can come back here to set
                    your preferences.
                  </div>
                )}
              </div>
            </div>
            {Object.entries(groupedSelectedDegrees).length > 0 && (
              <div className="box text-center mb-3">
                <Typography variant="h4" className="ms-3 text-success">
                  Reorder the programs by dragging them up or down to set your
                  preferences.
                </Typography>
              </div>
            )}

            {/* Filter Section */}
            <div className="row mb-4">
              <div className="col-md-4 mb-2">
                <label className="form-label">Campus</label>
                <Select
                  value={selectedCampus}
                  onChange={handleCampusChange}
                  options={campuses}
                  isClearable
                  placeholder="Select Campus"
                  className="basic-select"
                  classNamePrefix="select"
                />
              </div>

              <div className="col-md-4 mb-2">
                <label className="form-label">Faculty</label>
                <Select
                  value={selectedFaculty}
                  onChange={handleFacultyChange}
                  options={faculties}
                  isClearable
                  placeholder="Select Faculty"
                  className="basic-select"
                  classNamePrefix="select"
                  isDisabled={!selectedCampus}
                />
              </div>

              <div className="col-md-4 mb-2">
                <label className="form-label">Department</label>
                <Select
                  value={selectedDepartment}
                  onChange={handleDepartmentChange}
                  options={departments}
                  isClearable
                  placeholder="Select Department"
                  className="basic-select"
                  classNamePrefix="select"
                  isDisabled={!selectedFaculty}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Search Program"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </div>
              <div className="col-md-3">
                <button
                  className="btn btn-secondary btn-lg w-100"
                  onClick={resetFilters}
                >
                  Reset Filters
                </button>
              </div>
            </div>

            {/* Programs Section */}
            {degrees.map((degree) => {
              // Get the temporary selected quotas for this program
              const programQuotas = tempSelectedQuotas[degree.program_id] || [];
              const selectedQuotaNames = programQuotas.map((q) => q.quota_name);

              // Separate quotas into priority and other categories
              const priorityQuotas = degree.criterias.filter(
                (quota) =>
                  quota.quota_name === "Open Merit" ||
                  quota.quota_name === "Self Finance"
              );
              const otherQuotas = degree.criterias.filter(
                (quota) =>
                  quota.quota_name !== "Open Merit" &&
                  quota.quota_name !== "Self Finance"
              );

              // State to control visibility of other quotas (you'll need to add this state in your component)
              // const [showAllQuotas, setShowAllQuotas] = useState({});
              const showAllForThisProgram =
                showAllQuotas[degree.program_id] || false;

              return (
                <div
                  key={degree.program_id}
                  className="row box mt-3 p-3 bg-light rounded shadow-sm"
                >
                  {/* Degree Name and Apply Button */}
                  <div className="col-md-8">
                    <Typography variant="h5">{degree.program_name}</Typography>
                    <Typography variant="body" style={{ fontSize: "16px" }}>
                      {degree.faculty_name}
                    </Typography>
                    <br />
                    <Typography variant="body" style={{ fontSize: "16px" }}>
                      {degree.department_name}
                    </Typography>
                  </div>
                  <div className="col-md-4 text-end">
                    <button
                      className="btn btn-primary"
                      onClick={() =>
                        applyProgram(
                          degree.program_id,
                          degree.program_name,
                          degree.program_group,
                          degree.enable_course_work_option
                        )
                      }
                    >
                      Apply Program
                    </button>
                  </div>
                  {degree.enable_course_work_option == 1 && (
                    <div className="col-md-12">
                      <Typography variant="body1" className="fw-bold">
                        Select Program Type Option:
                      </Typography>
                      <div className="row">
                        <div className="col-md-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`workOption-${degree.program_id}`} // Make name unique per program
                              id={`researchWork-${degree.program_id}`}
                              value="research"
                              checked={
                                selectedProgramTypes[degree.program_id] ===
                                  "research" ||
                                !selectedProgramTypes[degree.program_id]
                              }
                              onChange={() =>
                                handleProgramTypeChange(
                                  degree.program_id,
                                  "research"
                                )
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`researchWork-${degree.program_id}`}
                            >
                              Research Work
                            </label>
                          </div>
                        </div>
                        <div className="col-md-10">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`workOption-${degree.program_id}`} // Make name unique per program
                              id={`courseWork-${degree.program_id}`}
                              value="course"
                              checked={
                                selectedProgramTypes[degree.program_id] ===
                                "course"
                              }
                              onChange={() =>
                                handleProgramTypeChange(
                                  degree.program_id,
                                  "course"
                                )
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`courseWork-${degree.program_id}`}
                            >
                              Course Work
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Selected Quotas Display */}
                  <div className="col-md-12 mb-2 mt-2">
                    <Typography variant="subtitle1" className="fw-bold">
                      Selected Quotas: {selectedQuotaNames.join(", ")}
                    </Typography>
                  </div>

                  {/* Priority Quotas (Open Merit and Self Finance) */}
                  {priorityQuotas.map((quota) => (
                    <div
                      key={quota.quota_id}
                      className="col-md-4 d-flex align-items-center ms-4 mb-2"
                    >
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`quota-${degree.program_id}-${quota.quota_id}`}
                          disabled={
                            !quota.eligible || quota.quota_name === "Open Merit"
                          }
                          checked={programQuotas.some(
                            (q) => q.quota_id === quota.quota_id
                          )}
                          onChange={() =>
                            handleQuotaSelection(
                              degree.program_id,
                              degree.program_name,
                              quota.quota_name,
                              quota.quota_id,
                              quota.test_required,
                              quota.test_name,
                              quota.eligible
                            )
                          }
                        />
                      </div>
                      <Typography variant="body1" className="ms-2">
                        {quota.quota_name}{" "}
                        {quota.quota_name === "Open Merit" && (
                          <span
                            className="text-success"
                            style={{ fontSize: "12px" }}
                          >
                            (Pre-selected)
                          </span>
                        )}
                        {!quota.eligible && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            (You are Not Eligible) {quota.reason}
                          </span>
                        )}
                      </Typography>
                    </div>
                  ))}

                  {/* Toggle Switch for Other Quotas */}
                  {otherQuotas.length > 0 && (
                    <div className="col-md-12 ms-4 mb-2 d-flex align-items-center">
                      <Typography variant="body2" className="me-2">
                        Any other quota applies to you?
                      </Typography>
                      <Switch
                        checked={showAllForThisProgram}
                        onChange={() =>
                          setShowAllQuotas((prev) => ({
                            ...prev,
                            [degree.program_id]: !prev[degree.program_id],
                          }))
                        }
                        color="primary"
                        size="medium"
                      />
                    </div>
                  )}

                  {/* Other Quotas (conditionally rendered) */}
                  {showAllForThisProgram &&
                    otherQuotas.map((quota) => (
                      <div
                        key={quota.quota_id}
                        className="col-md-4 d-flex align-items-center ms-4 mb-2"
                      >
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`quota-${degree.program_id}-${quota.quota_id}`}
                            disabled={!quota.eligible}
                            checked={programQuotas.some(
                              (q) => q.quota_id === quota.quota_id
                            )}
                            onChange={() =>
                              handleQuotaSelection(
                                degree.program_id,
                                degree.program_name,
                                quota.quota_name,
                                quota.quota_id,
                                quota.test_required,
                                quota.test_name,
                                quota.eligible
                              )
                            }
                          />
                        </div>
                        <Typography variant="body1" className="ms-2">
                          {quota.quota_name}{" "}
                          {!quota.eligible && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              (You are Not Eligible)
                            </span>
                          )}
                        </Typography>
                      </div>
                    ))}

                  <Typography variant="body1" className="ms-4 mt-2 mb-3">
                    {degree.description}
                  </Typography>
                  <Divider />
                </div>
              );
            })}
          </div>
        )}
        {applicationId && (
          <div className="row mt-3">
            <div className="col-md-10"></div>
            <div className="col-md-2">
              <Button
                variant="contained"
                color="primary"
                className="mt-3"
                style={{ color: "white", width: "100%" }}
                onClick={submitStep3}
              >
                Submit
              </Button>
            </div>
          </div>
        )}
      </MDBox>
    </DashboardLayout>
  );
};

export default ProgramCorrection;
